module.exports = __webpack_public_path__ + "img/vote-time.552df7ac.svg";